<template>
  <intersect :threshold="[0.5]" @enter="enter()" @leave="leave()">
    <div
      class="slider aspect-ratio--105x134 aspect-ratio--3x4-l"
      :class="isExpanded ? 'slider--expanded' : ''"
    >
      <div
        :key="slide.index"
        v-for="(slide, i) in slides"
        @click="onClick(i, $event)"
        class="slide aspect-ratio aspect-ratio--105x134 aspect-ratio--3x4-l"
      >
        <div class="slide__inner" :style="{backgroundImage: `url(${slide.image})`}"></div>
      </div>
    </div>
  </intersect>
</template>

<script>
import s from "../store"
import anime from "animejs"
import Intersect from "vue-intersect"

export default {
  name: "PhotoStack",

  components: { Intersect },

  props: {
    images: Array
  },

  data() {
    return {
      sharedState: s.state,
      isExpanded: false,
      isAnimating: false,
      index: 3,
      slides: []
    }
  },

  created: function() {
    if (s.debug)
      console.log(
        "Vue Component PhotoStack is created with image array: ",
        this.images
      )

    this.index = this.images.length
    this.slides = this.images
  },

  methods: {
    onClick: function(i, event) {
      if (i === this.slides.length - 1) {
        this.animateSlide(event.target)
      }
    },

    enter: function() {
      // if (this.isExpanded) {
      this.isExpanded = true
      // } else {
      //   this.isExpanded = true
      // }
    },

    leave: function() {
      // if (this.isExpanded) {
      this.isExpanded = false
      // } else {
      //   this.isExpanded = true
      // }
    },

    animateSlide: function(el) {
      if (this.isAnimating) {
        return
      }
      this.isAnimating = true
      anime({
        targets: el.parentNode,
        opacity: [1, 0],
        translateY: [-60, -120],
        translateX: [-60, -60],
        duration: 600,
        easing: "easeOutCubic",
        complete: this.onAnimationComplete
      })
    },

    onAnimationComplete: function() {
      this.index += 1
      const slide = this.slides.pop()
      slide.index = this.index
      this.slides.unshift(slide)
      this.isAnimating = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slider {
  width: calc(100% - 52px);
  display: flex;
  position: relative;
  margin-left: 52px;

  @media screen and (min-width: 60em) {
    width: 100%;
    margin-left: 72px;
  }
}

.slide {
  max-width: 100%;
  width: 100%;
  position: absolute;
  transition: transform 333ms cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
.slide:last-child {
  cursor: pointer;
}
.slide:last-child .slide__inner:hover {
  transform: scale(1.05);
}

.slider--expanded .slide:nth-child(2) {
  transform: translate3d(-18px, -18px, 0);
}
.slider--expanded .slide:nth-child(3) {
  transform: translate3d(-38px, -38px, 0);
}
.slider--expanded .slide:nth-child(4) {
  transform: translate3d(-56px, -56px, 0);
}
@media screen and (min-width: 60em) {
  .slider--expanded .slide:nth-child(2) {
    transform: translate3d(-24px, -24px, 0);
  }
  .slider--expanded .slide:nth-child(3) {
    transform: translate3d(-48px, -48px, 0);
  }
  .slider--expanded .slide:nth-child(4) {
    transform: translate3d(-72px, -72px, 0);
  }
}

.slide__inner {
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;

  transition: transform 100ms cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
</style>
